import { ZSpecCommon } from "src/business/specification";
import {
  combineChecked,
  GroupChecked,
} from "src/components/ReactiveTable/utils/groupChecked";

import { AttrVisitor } from "../AttrVisitor";
import { walkAttrsInSpecs } from "../AttrVisitor/walkAttr";

export const makeInitialSelection = (
  specs: ZSpecCommon[],
  attrIds: string[],
) => {
  const attrsSet = new Set(attrIds);
  const result: Record<string, GroupChecked> = {};
  const visitor: AttrVisitor = {
    onLeaf({ uid }) {
      result[uid] = attrsSet.has(uid) ? "all" : "none";
    },
    onLeave({ uid }, type) {
      result[uid] =
        type.fields?.reduce(
          (acc: GroupChecked | undefined, it) =>
            combineChecked(acc, result[it.uid]),
          undefined,
        ) ?? "none";
    },
  };
  walkAttrsInSpecs(specs, visitor);
  return result;
};
